<dgx-components-panel
  *ngIf="customerDetails"
  [border]="border"
  [rounded]="rounded"
  [variant]="variant"
>
  <h2 class="mb-4 typog-h3 protection-confirmation-panel__title">
    {{
      'SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_CUSTOMER_DETAILS'
        | translate
    }}
  </h2>

  <dgx-components-description-list>
    <dgx-components-description-list-item
      [data]="customerDetails.firstName + ' ' + customerDetails.lastName"
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_NAME' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="customerDetails.email"
      [data]="customerDetails.email"
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_EMAIL' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="customerDetails.phone && customerDetails.phone.Home !== null"
      [data]="customerDetails.phone.Home"
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_PHONE' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="customerDetails.billingAddress"
      [data]="
        customerDetails.billingAddress | dgxUsAddressToArray | conjunction : ','
      "
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_ADDRESS'
          | translate
      "
      [variant]="'bordered'"
    />
  </dgx-components-description-list>
</dgx-components-panel>
